// Source Check (#595) — derives the live-DB reconciliation badge for a change
// request from its status + latest reconciliation result. Single source of truth
// shared by the Change Control table column and the detail drawer so the two can't
// drift. Always returns an object (never null) — 'NA' when a check doesn't apply.
export function sourceCheckMeta(row) {
  if (!row) return {label: 'NA', cls: 'chip-grey'};
  if (row.status === 'IMPLEMENTED') return {label: 'Implemented', cls: 'chip-green'};
  if (row.status === 'REJECTED') {
    if (row.source_check_result === 'STILL_IN_DB') return {label: 'Still In DB', cls: 'chip-orange'};
    if (row.source_check_result === 'SOURCE_UNREACHABLE') return {label: 'Unreachable', cls: 'chip-grey'};
    if (row.source_check_result === 'REVERTED') return {label: 'Reverted', cls: 'chip-green'};
    return {label: 'Not checked', cls: 'chip-grey'};
  }
  return {label: 'NA', cls: 'chip-grey'};
}
